module.exports = __webpack_public_path__ + "img/title-en-min.9c8c591b.svg";